import "./Contact.module.css";
import NavigationHub from "@/reusable_sections/Header";
import InitiateContact from "./sections/InitiateContact";
import GlobalReach from "./sections/GlobalReach";
import CommonInquiries from "./sections/CommonInquiries";
import TheLabFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <NavigationHub />
      <InitiateContact />
      <GlobalReach />
      <CommonInquiries />
      <TheLabFooter />
    </div>;
}